import * as Yup from 'yup';

export const RegistroDeudaEnvaseHistorialValues = (deuda_envase_id, metodo_intercambio) => {
    return {
        initialValues: {
            deuda_envase_id: deuda_envase_id,
            metodo_pago_garantia: 'efectivo',
            monto_efectivo: 0,
            monto_transferencia: 0,
            cantidad: 0,
            obs: '',
        },
        fieldsValidation: Yup.object().shape({
            // cantidad: NumberIntegerRequired,            
        }),
        fields: [
            ...(metodo_intercambio === 'garantía' ?
                [
                    {
                        label: 'Método de pago',
                        name: 'metodo_pago_garantia',
                        type: 'select',
                        required: true,
                        options: [
                            {
                                label: 'Efectivo',
                                value: 'efectivo'
                            },
                            {
                                label: 'Transferencia',
                                value: 'transferencia'
                            },
                            {
                                label: 'Cheque',
                                value: 'cheque'
                            },
                            {
                                label: 'Combinado E/T',
                                value: 'combinado'
                            },
                        ],
                    },
                    {
                        label: 'Monto efectivo',
                        name: 'monto_efectivo',
                        type: 'groupnumber',
                        subData: 'Bs.',
                        disabled: false,
                        required: true,
                        ChangeCondition: (values, setValues, setAditionalClass) => {
                            if (['efectivo', 'combinado'].includes(values.metodo_pago_garantia))
                                setAditionalClass('')
                            else
                                setAditionalClass('hidden')
                        },
                        fieldDependency: 'metodo_pago_garantia',
                        highlight: 'bg-green-600 dark:bg-green-500 bg-opacity-25 dark:bg-opacity-20'
                    },
                    {
                        label: 'Monto transferencia',
                        name: 'monto_transferencia',
                        type: 'groupnumber',
                        subData: 'Bs.',
                        disabled: false,
                        required: true,
                        ChangeCondition: (values, setValues, setAditionalClass) => {
                            if (['transferencia', 'cheque', 'combinado'].includes(values.metodo_pago_garantia))
                                setAditionalClass('')
                            else
                                setAditionalClass('hidden')
                        },
                        fieldDependency: 'metodo_pago_garantia',
                        highlight: 'bg-green-600 dark:bg-green-500 bg-opacity-25 dark:bg-opacity-20'
                    },
                ]
                :
                []
            ),
            {
                label: 'Envases recogidos',
                name: 'cantidad',
                type: 'number',
                subData: null,
                required: true,
            },
            {
                type: 'divider'
            },
            {
                label: 'Observaciones',
                name: 'obs',
                type: 'textArea',
                required: false,
                placeholder: 'Observaciones...',
                autoFocus: false
            },
        ]
    }
}

export const EditarObsDeudaEnvaseHistorialValues = (deudaEnvaseHistorialId, obs) => {
    return {
        initialValues: {
            deudaEnvaseHistorialId: deudaEnvaseHistorialId,
            obs: obs || '',
        },
        fieldsValidation: Yup.object().shape({
            // cantidad: NumberIntegerRequired,            
        }),
        fields: [
            {
                label: 'Observaciones',
                name: 'obs',
                type: 'textArea',
                required: false,
                placeholder: 'Observaciones...',
                autoFocus: false
            },
        ]
    }
}

export const DeleteValues = (data) => {
    return {
        initialValues: {
        },
        fieldsValidation: Yup.object().shape({
        }),
        fields: []
    }
}